var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmenting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1656577239875,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3459,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M874.182656 149.919744C777.459712 53.256192 648.906752 0 512.098304 0 375.339008 0 246.777856 53.256192 150.09792 149.929984 53.379072 246.636544 0.116736 375.222272 0.116736 512.002048c-0.024576 136.798208 53.200896 265.35936 149.901312 362.119168C246.687744 970.74176 375.261184 1024 512.008192 1024c136.808448 0 265.426944-53.295104 362.174464-149.981184C1073.768448 674.41664 1073.79712 349.605888 874.182656 149.919744zM752.982016 695.724032c-11.778048 20.39808-33.880064 27.387904-54.272 15.618048l-176.003072-106.668032c-5.931008-3.418112-15.65696-8.237056-19.2-13.568C490.708992 583.766016 471.04 570.497024 471.04 554.67008L471.04 256.004096c0-23.554048 19.113984-42.67008 42.661888-42.67008 23.554048 0 42.672128 19.113984 42.672128 42.67008l0 279.12192 176.979968 102.356992C753.793024 649.259008 764.758016 675.325952 752.982016 695.724032z",
    "p-id": 3460,
    fill: "#FACF18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmenting);
export default __webpack_public_path__ + "static/media/appointmenting.be7f9f66.svg";
export { ForwardRef as ReactComponent };